<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label for="shift">Управление сменами</label>
          <md-select v-model="value" name="shift" id="shift" @md-selected="changeFilter" md-dense>
            <md-option v-for="v in items"
                       :value="v.value"
                       :key="v.value">{{ v.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shift',
  data () {
    return {
      items: [{name: 'Все', value: 'deleteFilter'},
        {name: 'Включено', value: 1},
        {name: 'Выключено', value: 0}
      ],
      value: null
    }
  },
  methods: {
    changeFilter () {
      this.$store.commit('setFilter', {name: 'is_check_operday_enabled', value: this.value})
      this.$emit('changeFilter')
    }
  },
  created () {
    if (this.$store.state.filtersShop['is_check_operday_enabled'] !== null) {
      this.value = this.$store.state.filtersShop.is_check_operday_enabled
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/shop/shift.vue